import React from "react";
import HeroSlider from "../component/HeroSlider";
import FacultyList from "../component/FacultyList";
import Footer from "../component/Footer";
import News from "../component/News";
import NoticeAndUpcomingEvents from "../component/NoticeAndUpcomingEvents";
import Testimonial from "./Testimonials";
import InternationalCollaboration from "../component/InternationalCollaboration";
import PhotoAlbum from "../component/PhotoAlbum";
import MessengerCustomerChat from "react-messenger-customer-chat";
import { AdmissionModal } from "../UI/AdmissionModal";
import { useSlider } from "../features/useSlider";
import Spinner from "../UI/Spinner";
import { useNews } from "../features/useNews";
import Message from "../component/Message";
import styled from "styled-components";
import { useNotices } from "../features/useNotices";

const StyledDiv = styled.div`
  width: 100vw;
  min-height: 100vh;
`;

const Home = () => {
  const Config = {
    home: true,
  };
  const { isLoading: sliderLoading, error: sliderError } = useSlider();
  const { isLoading: newsLoading, error: newsError } = useNews(Config);
  const { isLoading: noticeLoading, error: noticeError } = useNotices(Config);

  const isWorking = sliderLoading || newsLoading || noticeLoading;

  const isError = sliderError || newsError || noticeError;

  if (isWorking) return <Spinner />;
  if (isError)
    return (
      <Message>
        <p>Somthing went wrong!🔥</p>
      </Message>
    );

  return (
    <StyledDiv>
      <HeroSlider config={Config} />
      <div className="NewsAndNoticeContainer">
        <News newsConfig={Config} />
        <NoticeAndUpcomingEvents noticeConfig={Config} />
      </div>
      <AdmissionModal />
      <FacultyList />
      <Testimonial />
      <PhotoAlbum />
      <InternationalCollaboration />
      <Footer />
      {/* <MessengerCustomerChat pageId="252121715162362" appId="742039663605788" /> */}
    </StyledDiv>
  );
};

export default Home;
